import request from "@/utils/request";

//获取会员展示图片
export function getMembersShowImages(type,pageNum,pageSize) {
  return request({
    url: "/members/show/list",
    method: "get",
    params:{
        type,
        pageNum,
        pageSize
    }
  });
}

